export class Speciality {
  SuffixName: string;
  SuffixID: number;
  IsActive: boolean
}